import script from "./ApplicationFullscreenView.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicationFullscreenView.vue?vue&type=script&setup=true&lang=js"

import "./ApplicationFullscreenView.vue?vue&type=style&index=0&id=21fcc302&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21fcc302"]])

export default __exports__